var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c(_vm.getFieldComponent(_vm.fieldInDB.format),{tag:"component",attrs:{"item":_vm.fieldInDB,"page":_vm.page,"modalKey":_vm.modalKey,"keyup":_vm.keyup,"change":_vm.change,"valField":_vm.model,"modal":_vm.modal,"hook":_vm.hook,"mod":_vm.mod}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }